import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-pix-keys-onboarding',
	templateUrl: './onboarding.component.html',
	styleUrls: ['./onboarding.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysOnboardingComponent implements OnInit {

	public step = 1;
	public title = '';
	public text = '';

	constructor(
		private router: Router
	) {}

	ngOnInit(): void {
		this.setTitleAndText();
	}

	setTitleAndText() {
		switch (this.step) {
			case 1:
				this.title = 'O registro da chave é necessário para receber um Pix de forma prática.';
				this.text = 'Com a chave, ao invés do pagador ter que digitar todas as informações para identificar sua conta, basta informar a chave registrada que pode ser o Número de Celular, CPF ou E-mail.';
				break;

			case 2:
				this.title = 'Cada chave só poderá ser vinculada a uma única conta.';
				this.text = 'Cada pessoa física poderá cadastrar até 5 chaves para uma mesma conta.';
				break;

			case 3:
				this.title = 'É possível registrar quatro tipos de chaves: ';
				this.text = 'Seu número de telefone celular, o seu CPF ou CNPJ, seu endereço de e-mail ou criar uma Chave aleatória.';
				break;
		}
	}

	prev() {
		this.step--;
		this.setTitleAndText();
	}

	next() {
		this.step++;
		this.step === 4 ? this.router.navigate(['pix/chaves/criar']) : this.setTitleAndText();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/onboarding/onboarding.component.ts